import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import { NavItem } from '@wdx/shared/utils';

@Component({
    selector: 'clmi-filter-table-responsive-card-template',
    templateUrl: './responsive-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FilterTableResponsiveCardTemplateComponent {
    @Input() data: any;

    @Output() toggleChange = new EventEmitter<any>();
    @Output() menuItemSelected = new EventEmitter<any>();

    onToggleChange(event: MouseEvent): void {
        this.toggleChange.emit(event);
    }

    onMenuItemSelected(navItem: NavItem): void {
        this.menuItemSelected.emit(navItem);
    }
}
